import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

// /curator is a shortcut into the auction room. The token-in-the-URL flow it
// once carried is commented out in git history; today it only redirects.
const UrlLoginCurator = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/curator/auction");
  }, []);

  return null;
};

export default UrlLoginCurator;
